// Incoherencias con el purchase

export const analyticsEvents = {
  app_general_view: 'app_general_view',
  auth_facebook_login: 'auth_facebook_login',
  auth_google_login: 'auth_google_login',
  auth_twitter_login: 'auth_twitter_login',
  begin_checkout: 'begin_checkout',
  button_click_menu_home: 'button_click_menu_home',
  button_click_menu_settings: 'button_click_menu_settings',
  checkout_progress: 'checkout_progress',
  click_home: 'click_home',
  click_link: 'click_link',
  click_mercado_pago_checkoutPro: 'click_mercado_pago_checkoutPro',
  click_more_info: 'click_more_info',
  click_nav_item: 'click_nav_item',
  cotizaciones_new_page_view: 'cotizaciones_new_page_view',
  creation_payment_market_payment: 'creation_payment_market_payment',
  finish_process_recharge_service: 'finish_process_recharge_service',
  handle_success_mp: 'handle_success_mp',
  landing_view: 'landing_view',
  licensee_page_view: 'licensee_page_view',
  login_click_button: 'login_click_button',
  login_page_view: 'login_page_view',
  login_register_click: 'login_register_click',
  new_user: 'new_user',
  package_detail_collection_page_view: 'package_detail_collection_page_view',
  package_detail_shipment: 'package_detail_shipment',
  package_pickup_page_view: 'package_pickup_page_view',
  package_receipt_detail_page_view: 'package_receipt_detail_page_view',
  package_shipping_page_view: 'package_shipping_page_view',
  page_view: 'page_view',
  payment_balance_qr: 'payment_balance_qr',
  payment_recharge_service_balance_locker: 'payment_recharge_service_balance_locker',
  payment_recharge_service_balance_locker_failed: 'payment_recharge_service_balance_locker_failed',
  purchase: 'purchase',
  purchase_recharge_services_failed: 'purchase_recharge_services_failed',
  purchase_recharge_services_successful: 'purchase_recharge_services_successful',
  quote_new_submit: 'quote_new_submit',
  quote_select_rate: 'quote_select_rate',
  quotes_new_page_view: 'quotes_new_page_view',
  recharge_service_selected: 'recharge_service_selected',
  refund_market_payment: 'refund_market_payment',
  refund_market_payment_failed: 'refund_market_payment_failed',
  refund_mercado_pago: 'refund_mercado_pago',
  register_page_view: 'register_page_view',
  restart_flow_locker: 'restart_flow_locker',
  search_trace_click: 'search_trace_click',
  shipping_quotation: 'shipping_quotation',
  subcategory_recharges_services: 'subcategory_recharges_services',
  user_account_view: 'user_account_view',
  view_item_list: 'view_item_list',
  wallet_page_view: 'wallet_page_view'
};

export const eventsLockers = {
  locker_balance: 'locker_balance',
  locker_balance_client_recurrent: 'locker_balance_client_recurrent',
  locker_balance_client_recurrent_used: 'locker_balance_client_recurrent_used',
  locker_balance_pay: 'locker_balance_pay',
  locker_balance_pay_failed: 'locker_balance_pay_failed',
  locker_final_flow_measurements_scale: 'locker_final_flow_measurements_scale',
  locker_final_print_guide: 'locker_final_print_guide',
  locker_finish_shipping: 'locker_finish_shipping',
  locker_init_flow_measurements_scale: 'locker_measurements_scale',
  locker_payment_methods_select: 'locker_payment_methods_select',
  locker_payment_methods_select_back: 'locker_balance_client_recurrent_used',
  locker_recharge_fail: 'locker_recharge_fail',
  locker_recharge_form_item: 'locker_recharge_form_item',
  locker_recharge_success: 'locker_recharge_success', // conversion
  locker_reset: 'locker_reset',
  locker_reset_final: 'locker_reset_final',
  locker_reset_inactivity: 'locker_reset_inactivity',
  locker_service_fail: 'locker_service_fail',
  locker_service_form_item: 'locker_service_form_item',
  locker_service_success: 'locker_service_success', // conversion
  locker_shipping_type_letter: 'locker_shipping_type_letter',
  locker_shipping_type_package: 'locker_shipping_type_package',
  locker_view: 'locker_view',
  locker_view_cost: 'locker_view_cost',
  locker_view_internacional: 'locker_view_internacional',
  locker_view_item_shipping: 'Item Shipping',
  locker_view_measures: 'locker_view_measures',
  locker_view_nacional: 'locker_view_nacional',
  locker_view_pay: 'locker_view_pay',
  locker_view_payment_methods: 'locker_view_payment_methods',
  locker_view_personal_information: 'locker_view_personal_information',
  locker_view_quote: 'locker_view_quote',
  locker_view_recargas: 'locker_view_recargas',
  locker_view_recharge_form_item: 'locker_view_recharge_form_item',
  locker_view_recharge_subcategories: 'locker_view_recharge_subcategories',
  locker_view_service_items_to_pay: 'locker_view_service_items_to_pay',
  locker_view_service_subcategories: 'locker_view_service_subcategories',
  locker_view_servicios: 'locker_view_servicios',
  locker_view_shipping_type: 'locker_view_shipping_type'
};
